let measurementId = null;
const sentRequests = new Set();
const events = new Set(['artist_profile_view', 'booking_start', 'booking_request_sent']);

/** Use the same GA4 web stream as the existing page-view tracking. */
export const configureBookingFunnel = id => {
  measurementId = typeof id === 'string' && id.startsWith('G-') ? id : null;
};

/** Send only anonymous listing/transaction IDs; analytics must never break booking. */
export const trackFunnelEvent = (name, params = {}) => {
  try {
    if (typeof window === 'undefined' || !measurementId || !window.gtag || !events.has(name)) {
      return false;
    }
    const safeParams = { send_to: measurementId };
    ['listing_id', 'transaction_id'].forEach(key => {
      if (typeof params[key] === 'string') safeParams[key] = params[key];
    });
    window.gtag('event', name, safeParams);
    return true;
  } catch (error) {
    return false;
  }
};

/** Count requests only after the real confirm-payment transition succeeds. */
export const trackBookingRequest = transaction => {
  const id = transaction?.id?.uuid;
  if (!id || transaction?.attributes?.lastTransition !== 'transition/confirm-payment') return;
  const key = `hg-request-tracked:${id}`;
  if (sentRequests.has(id)) return;
  try {
    if (window.sessionStorage?.getItem(key)) return;
  } catch (error) {
    // Storage can be disabled; in-memory deduplication still applies.
  }
  const context = transaction?.attributes?.protectedData?.hgAnalytics;
  const listingId = context?.listing_id || transaction?.relationships?.listing?.data?.id?.uuid;
  if (!trackFunnelEvent('booking_request_sent', { transaction_id: id, listing_id: listingId })) return;
  sentRequests.add(id);
  try {
    window.sessionStorage?.setItem(key, '1');
  } catch (error) {
    // Do not interrupt checkout if storage is unavailable.
  }
};

/** Capture GA's existing anonymous customer identity for later server acceptance. */
export const getBookingAnalyticsContext = async listingId => {
  if (typeof window === 'undefined' || !window.gtag || !measurementId) return null;
  const get = field => new Promise(resolve => {
    const timer = setTimeout(() => resolve(null), 200);
    try {
      window.gtag('get', measurementId, field, value => {
        clearTimeout(timer);
        resolve(value == null ? null : String(value));
      });
    } catch (error) {
      clearTimeout(timer);
      resolve(null);
    }
  });
  const [clientId, sessionId] = await Promise.all([get('client_id'), get('session_id')]);
  if (!clientId || !sessionId || !/^\d+$/.test(sessionId)) return null;
  return {
    client_id: clientId,
    session_id: sessionId,
    measurement_id: measurementId,
    listing_id: listingId,
  };
};
